import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { OTHER } from '../../config/api.config';

const GoldPriceTest = () => {
  const [prices, setPrices] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [rawData, setRawData] = useState(null);

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        setLoading(true);
        console.log('Fetching gold prices from:', OTHER.GOLD_PRICE);
        
        const response = await axios.get(OTHER.GOLD_PRICE);
        console.log('Raw API response:', response.data);
        setRawData(response.data);

        const priceMap = {};
        response.data.forEach((item) => {
          priceMap[item.Carat] = item.TodayPricePerGram;
        });

        console.log('Processed price map:', priceMap);
        setPrices(priceMap);
        setError(null);
      } catch (err) {
        console.error('Error fetching prices:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPrices();
  }, []);

  if (loading) return <div className="p-4">Loading gold prices...</div>;
  if (error) return <div className="p-4 text-red-500">Error: {error}</div>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Gold Price Test</h1>
      
      <div className="mb-4">
        <h2 className="text-lg font-semibold mb-2">API Endpoint:</h2>
        <code className="bg-gray-100 p-2 rounded">{OTHER.GOLD_PRICE}</code>
      </div>

      <div className="mb-4">
        <h2 className="text-lg font-semibold mb-2">Raw API Response:</h2>
        <pre className="bg-gray-100 p-3 rounded overflow-auto text-sm">
          {JSON.stringify(rawData, null, 2)}
        </pre>
      </div>

      <div className="mb-4">
        <h2 className="text-lg font-semibold mb-2">Processed Prices:</h2>
        <pre className="bg-gray-100 p-3 rounded overflow-auto text-sm">
          {JSON.stringify(prices, null, 2)}
        </pre>
      </div>

      <div className="mb-4">
        <h2 className="text-lg font-semibold mb-2">Price Display Test:</h2>
        <div className="grid grid-cols-2 gap-4">
          {Object.entries(prices).map(([carat, price]) => (
            <div key={carat} className="bg-white p-4 rounded shadow">
              <h3 className="font-bold">{carat} Price</h3>
              <p className="text-2xl">₹ {price?.toLocaleString() || '...'}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GoldPriceTest;
